"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndpointOut = void 0;
class EndpointOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EndpointOut.attributeTypeMap;
    }
}
exports.EndpointOut = EndpointOut;
EndpointOut.discriminator = undefined;
EndpointOut.attributeTypeMap = [
    {
        "name": "channels",
        "baseName": "channels",
        "type": "Array<string>",
        "format": ""
    },
    {
        "name": "createdAt",
        "baseName": "createdAt",
        "type": "Date",
        "format": "date-time"
    },
    {
        "name": "description",
        "baseName": "description",
        "type": "string",
        "format": ""
    },
    {
        "name": "disabled",
        "baseName": "disabled",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "filterTypes",
        "baseName": "filterTypes",
        "type": "Array<string>",
        "format": ""
    },
    {
        "name": "id",
        "baseName": "id",
        "type": "string",
        "format": ""
    },
    {
        "name": "metadata",
        "baseName": "metadata",
        "type": "{ [key: string]: string; }",
        "format": ""
    },
    {
        "name": "rateLimit",
        "baseName": "rateLimit",
        "type": "number",
        "format": "uint16"
    },
    {
        "name": "uid",
        "baseName": "uid",
        "type": "string",
        "format": ""
    },
    {
        "name": "updatedAt",
        "baseName": "updatedAt",
        "type": "Date",
        "format": "date-time"
    },
    {
        "name": "url",
        "baseName": "url",
        "type": "URI",
        "format": "uri"
    },
    {
        "name": "version",
        "baseName": "version",
        "type": "number",
        "format": "int32"
    }
];
//# sourceMappingURL=EndpointOut.js.map